"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDataSelector = void 0;
const Selector_1 = require("./Selector/Selector");
class FormDataSelector {
    constructor(form) {
        this.form = form;
        this.selector = new Selector_1.Selector();
    }
    set(selector, value) {
        this.selector.set(selector, value, this.form.data);
    }
    trySet(selector, value) {
        return this.selector.trySet(selector, value, this.form.data);
    }
    get(selector) {
        return this.selector.get(selector, this.form.data);
    }
    tryGet(selector) {
        return this.selector.tryGet(selector, this.form.data);
    }
    getOrNull(selector) {
        return this.selector.getOrNull(selector, this.form.data);
    }
    delete(selector) {
        this.selector.delete(selector, this.form.data);
    }
    tryDelete(selector) {
        return this.selector.tryDelete(selector, this.form.data);
    }
    has(selector) {
        return this.selector.has(selector, this.form.data);
    }
}
exports.FormDataSelector = FormDataSelector;
